<template>
  <div class="detailCamsSetting">
    <section ref="resizableElm">
      <div class="d-flex justify-space-between">
        <setting-header v-if="groupCams && groupCams.length" />
        <v-menu
          v-if="!isEdit"
          left
          offset-y
          content-class="listCamsSetting_menu"
          z-index="99"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              text
              class="listCamsSetting_menu-btn"
              :class="{}"
              v-on="on"
            >
              <span class="icon icon-3dots" />
            </v-btn>
          </template>
          <v-list class="listCamsSetting_menu-list">
            <v-list-item v-if="!hideEdit" @click="handleEdit">
              <v-list-item-title>
                <img src="@/assets/img/icon_24_setting.svg" class="" alt="" />
                <span>カメラグループの編集</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="handleOrder">
              <v-list-item-title>
                <img src="@/assets/img/ico_list_tile.svg" class="" alt="" />
                <span>リスト順の編集</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!hideEdit" @click="handleSelect">
              <v-list-item-title>
                <img src="@/assets/img/ico_select.svg" class="" alt="" />
                <span>カメラを選択する</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <section
        v-if="!isSorting && !hideEdit"
        class="detailCamsSetting_tabs-wrapper"
      >
        <v-tabs
          v-model="tabs"
          height="32px"
          centered
          dense
          :hide-slider="true"
          class="detailCamsSetting_tabs"
          active-class="detailCamsSetting_tabs-active"
        >
          <v-tab
            v-for="(item, index) in tabItems"
            :key="index"
            @change="handleTab(item.index)"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>
      </section>
    </section>
    <section class="detailCamsSetting_wrapper">
      <main>
        <transition name="fade">
          <cam-detail-list
            v-if="tabs === 0"
            hide-status
            :search-query.sync="searchQuery"
            :filtered-items="filteredGroupSettings"
            :is-selecting.sync="isSelecting"
            :is-sorting.sync="isSorting"
            @handleCancel="handleCancel"
          />
          <cam-detail-account
            v-else
            :search-query.sync="searchQuery"
            :filtered-items="filteredAccountItems"
            :loading="loading"
            :group="currentGroup"
            @deleteAccounts="handleDeleteAccounts"
          />
        </transition>
      </main>
    </section>
  </div>
</template>

<script>
import SettingHeader from '../SettingHeader.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { videoService } from '@/services/video.service';
import ResizeMixin from '@/mixin/resizeMixin';
import CamDetailList from './CamDetailList.vue';
import CamDetailAccount from './CamDetailAccount.vue';
import { AllCamerasIdGroup } from '@/globals/constants';
export default {
  name: 'DetailCamsSetting',
  components: {
    SettingHeader,
    CamDetailList,
    CamDetailAccount,
  },
  mixins: [ResizeMixin],
  props: {
    routeLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedCams: {},
      allSelected: false,
      oldSelectedCams: {},
      displayCam: null,
      submitLoading: false,
      isChanged: false,
      tabs: 0,
      query: '',
      loading: false,
      isEdit: false,
      isSorting: false,
      isSelecting: false,
      deletedAccounts: [],
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters('settings', {
      users: 'usersWithOwner',
    }),
    ...mapState({
      items: (state) => state.common.cameraList,
      iamKey: (state) => state.common.iam.accessKeyId,
      iamSecret: (state) => state.common.iam.secretAccessKey,
      groupCams: (state) => state.settings.groupCams,
      groupCamsChecklist: (state) => state.settings.groupCamsChecklist,
    }),
    id() {
      return this.$route.params.id;
    },
    currentGroup() {
      return this.groupCams.find((g) => String(g.id) === String(this.id));
    },
    hideEdit() {
      return +this.id === AllCamerasIdGroup;
    },
    cams() {
      return this.currentGroup
        ? this.currentGroup.details.map((c) => ({ ...c, name: c.title }))
        : [];
    },
    filteredGroupSettings() {
      const currentGroup = this.groupCamsChecklist.find(
        (g) => String(g.id) === String(this.id)
      );
      const cams = currentGroup
        ? currentGroup.details.map((c) => ({ ...c, name: c.title }))
        : [];
      return this.query && this.query !== ''
        ? cams.filter((c) => {
            return c.name.toLowerCase().includes(this.query.toLowerCase());
          })
        : cams;
    },
    filteredGroupItems() {
      return this.query && this.query !== ''
        ? this.cams.filter((c) => {
            return c.name.toLowerCase().includes(this.query.toLowerCase());
          })
        : this.cams;
    },
    filteredAccountItems() {
      let filteredUsers = this.users;
      if (this.id) {
        // Show users belong to selected group cam id
        filteredUsers = this.users.filter((user) =>
          user.groupCams?.groupCamIds?.includes(+this.id)
        );
      }
      if (this.deletedAccounts.length) {
        // Remove deleted accounts from table
        filteredUsers = filteredUsers.filter(
          (obj) => !this.deletedAccounts.includes(obj.id)
        );
      }
      return filteredUsers;
    },
    tabItems() {
      return [
        {
          label:
            'カメラ一覧' +
            (this.filteredGroupItems && this.filteredGroupItems.length > 0
              ? ` ${this.filteredGroupItems.length}`
              : ''),
          value: 'list',
          index: 0,
        },
        {
          label:
            'ユーザー一覧' +
            (this.filteredAccountItems && this.filteredAccountItems.length > 0
              ? ` ${this.filteredAccountItems.length}`
              : ''),
          value: 'account',
          index: 1,
        },
      ];
    },
  },
  watch: {
    $route(to) {
      this.isSorting = to.name === 'settings-cams-list-detail-edit-sorting';
      this.isEdit = this.isSorting;
    },
    groupCams: {
      handler: function (val) {
        const currentGroup = val.find(
          (group) => String(group.id) === String(this.id)
        );
        if (currentGroup) {
          let selectedCams = {};
          currentGroup.details.forEach((cam) => {
            selectedCams = { ...selectedCams, [cam.index]: true };
          });
          this.selectedCams = selectedCams;
          this.oldSelectedCams = { ...this.selectedCams };
        }
      },
      deep: true,
      immediate: true,
    },
    selectedCams: {
      handler: function (val) {
        this.isChanged = this.checkAnyChange(val);
      },
      deep: true,
    },
    searchQuery(val) {
      this.query = val || '';
    },
  },
  mounted() {
    this.init();
  },
  created() {
    if (this.$route.name === 'settings-cams-list-detail-edit-sorting') {
      this.isSorting = true;
    }
  },
  methods: {
    ...mapActions('settings', [
      'setCurrentSelectedCamsGroup',
      'updateCameraGroup',
      'fetchUserAvatarList',
    ]),
    async init() {
      try {
        this.loading = true;
        await this.fetchUserAvatarList();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleQuery(q) {
      this.query = q;
      this.routerReplace({
        query: { q },
      });
    },
    handleTab() {},
    handleCancel() {
      this.isEdit = false;
    },
    checkAnyChange(selectedCams) {
      const a = Object.keys(selectedCams).filter((key) => selectedCams[key]);
      const b = Object.keys(this.oldSelectedCams).filter(
        (key) => this.oldSelectedCams[key]
      );
      const diff =
        a.length > b.length
          ? a.filter((e) => !b.includes(e))
          : b.filter((e) => !a.includes(e));
      return diff.length > 0;
    },
    async handleSubmit() {
      try {
        this.submitLoading = true;
        const camsToUpdate = [];
        const updates = [];
        const selectedCamIndexes = Object.keys(this.selectedCams).filter(
          (key) => this.selectedCams[key]
        );
        this.items.forEach((cam, camIndex) => {
          let isChanged = false;
          let groupIds =
            cam.tagInfoList && cam.tagInfoList.length
              ? cam.tagInfoList.map((camTag) => String(camTag.id))
              : [];
          const thisCamSelected = selectedCamIndexes.includes(String(camIndex));
          if (thisCamSelected && !groupIds.includes(String(this.id))) {
            // Whether need to add a group id in camera
            groupIds.push(this.id);
            isChanged = true;
          } else if (!thisCamSelected && groupIds.includes(String(this.id))) {
            // Whether need to remove a group id from camera
            groupIds = groupIds.filter(
              (groupId) => String(groupId) !== String(this.id)
            );
            isChanged = true;
          }

          if (isChanged) {
            camsToUpdate.push({
              id: cam.id,
              groupId: groupIds.map((id) => Number(id)),
            });
          }
        });

        camsToUpdate.forEach((camUpdate) => {
          updates.push(this.updateCameraGroup(camUpdate));
        });
        await Promise.all(updates);

        await videoService.getCameraListWithGroup(),
          this.$router.push({
            name: 'settings-cams-list',
            params: { group: this.$route.params.group },
          });
      } catch (error) {
        console.error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    handleSelectCam() {
      this.allSelected =
        Object.values(this.selectedCams).filter((selected) => selected)
          .length === this.items.length;
    },
    handleSelectAll(selected) {
      this.items.forEach((cam, index) => {
        this.$set(this.selectedCams, index, selected);
      });
    },
    handleDisplayCam(cam) {
      this.displayCam = cam;
    },
    navigateTo(to) {
      this.$router.push(to);
    },
    handleOrder() {
      this.query = null;
      this.tabs = 0;
      this.isEdit = true;
      this.isSelecting = false;
      this.isSorting = true;
      this.routerPush({
        name: 'settings-cams-list-detail-edit-sorting',
      });
    },
    handleEdit() {
      this.routerPush({
        name: 'settings-cams-list-detail-edit',
      });
    },
    handleSelect() {
      this.tabs = 0;
      this.isSorting = false;
      this.isSelecting = true;
    },
    handleDeleteAccounts(deletedId) {
      this.deletedAccounts.push(deletedId);
    },
  },
};
</script>

<style lang="scss">
.detailCamsSetting {
  position: relative;
  height: 100%;
  &_tabs {
    width: 337px;

    .v-slide-group__content.v-tabs-bar__content {
      border-radius: 5px;
      background-color: #eee;
      padding: 2px 0;
    }
    .v-tab {
      font-size: 13px;
      width: 166px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: normal;
      text-align: left;
    }
    &-active {
      border-radius: 5px;
      background-color: #fff;
      color: #0075c2;
    }
    &-wrapper {
      position: relative;
      margin: 15px 0;
      width: 342px;
      height: 25px;
    }
  }
  &_loading {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
  &_wrapper {
    height: calc(100% - 5px);
    overflow-y: auto;
  }
  &_edit {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    &.v-btn.v-size--default {
      font-size: 15px;
    }
  }
  &_flex-gap {
    display: flex;
    flex: 1;
  }
  &_divider {
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }

  &_live {
    width: 34px;
    height: 17px;
    padding: 0 4px;
    border-radius: 3px;
    background-color: #79c06e;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: 0.13px;
    text-align: left;
    color: #fff;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  header {
    margin-top: 25px;
    margin-bottom: 10px;
    h5 {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
    }
    .customCheck {
      margin-top: 20px;
      margin-left: 10px;
      .customCheck_label {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
    }
  }
  main {
    width: 100%;
  }
  &_actions {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  &_submit {
    &.theme--light.v-btn.v-btn--has-bg {
      width: 120px;
      height: 36px;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-color: #0075c2;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: left;
      color: #fff;
    }
    &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #f3f3f3 !important;
      box-shadow: none;
      color: #ccc !important;
    }
  }
  &_left {
    min-width: 300px;
    margin-right: 50px;
    .customCheck {
      padding: 12px 10px;
      &:not(:last-child) {
        border-bottom: 1px solid #eee;
      }
    }
  }
  &_righ {
    margin-top: 11px;
    padding: 0 10px;
    @media (max-width: 1199px) {
      padding: 0;
      margin-bottom: 10px;
    }
    .detailCamsSetting_cam {
      position: relative;
    }
    h5 {
      margin-top: 5px;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
  }
}
</style>
